/* globals updateEventBind */
(function () {
	'use strict';

	angular.module('app.dashboard')
		.controller('projectedShortagesChartCtrl', projectedShortagesChart);

	function projectedShortagesChart($rootScope, $scope, $timeout, config, 
			dashboardFilterInitializationService, leanFilterService, storeService, projectedShortageService, pageTimingService,
		 	$experiments, drilldownFunctionsService) {
		$scope.$parent.$parent.showViewReport = false;
		$scope.isReadOnly = storeService.getState().reportSettings.readOnly;
		$scope.slideshowView = $rootScope.slideshowView;
		$scope.$parent.$parent.showViewReport = true;

		updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged',
			'slideshowViewChanged', 'inventoryFilterChanged']);
		$scope.settings = {};

		for (var settingName in config.settings) {
			if (config.settings.hasOwnProperty(settingName)) {
				$scope.settings[settingName] = config.settings[settingName];
			}
		}

		// controls in the widget title bar are in different scope
		var widgetContainerScope = $scope.$parent.$parent;
		if (config.settings === undefined) {
			$scope.settings.itemType = 'Purchased';
			$scope.settings.bucketType = 'weeks';
			$scope.showEditConfig = true;
			widgetContainerScope.hidePencil = true;
		} else {
			setWidgetTitle();
		}

		widgetContainerScope.editWidgetSettings = function () {
			$scope.showEditConfig = true;
			widgetContainerScope.hidePencil = true;
		};

		$scope.saveWidgetSettings = function(doNotReload) {
			$scope.showEditConfig = false;
			widgetContainerScope.hidePencil = false;
			// save config
			var widget = $scope.$parent.model;
			widget.config.settings = $scope.settings;
			pendo.track('widgetChangeConfig', {
				widgetType: widget.config.type,
				mode: $scope.settings
			});
			var columnDefinition = $scope.$parent.$parent.col;
			if (!$scope.isReadOnly) {
				storeService.dispatch({
					type: storeService.actions.CONFIG_WIDGET_UPDATE_ONE,
					payload: {
						column: 'column' + columnDefinition.columnIndex,
						position: columnDefinition.widgets.indexOf(widget),
						widget: {
							name: widget.config.type,
							config: _.cloneDeep(widget.config)
						}
					},
					meta: {
						reportName: undefined,
						reportSettingsId: globalReportName
					}
				});
			}
			setWidgetTitle();
			
			loadData();
		};

		// Set navigation properties
		$scope.emptyHeader = 'We couldn\'t find any results.';
		$scope.emptySuggestion = '';
		$scope.emptyLinkText = '';

		function getMonth(numMonths) {
			return (moment().add(numMonths, 'months')).toDate();
		}

		function getChart() {
			projectedShortageService.getChartData($scope.settings).then(function (result) {
				$scope.loading = false;
				if (result.data && result.data.length) {
					$scope.chartData = {};
					var chartData = [];
					var noOfBuckets = $scope.settings.bucketType === 'weeks' ? 13: 12;
					var record = result.data[0];
					if (record) {
						for (var i = 1; i <= noOfBuckets; i++) {
							chartData.push({
								'date': $scope.settings.bucketType === 'weeks' ? record['bucket' + i + 'EndDate'] : getMonth(i - 1),
								'itemCount': record['bucket' + i + 'ItemCount']
							});
						}
					}
					if (chartData.length) {
						$scope.chartData = chartData;
					} else {
						$scope.empty = true;
					}
				} else {
					$scope.empty = true;
				}
				$scope.$broadcast('event:projectedShortagesCtrl:getChart', null);
				if (!$scope.slideshowView) {
					var columnDefinition = $scope.$parent.$parent.col;
					var curWidget = $scope.$parent.model;
					pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
			});
		}

		function loadData() {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
				getChart();

				var filterQueryParams = leanFilterService.getQueryParamsObject(true, true);
				filterQueryParams['factory'] = leanFilterService.getFactoryList();
				filterQueryParams['bucketType'] = $scope.settings.bucketType;
				filterQueryParams['itemType'] = $scope.settings.itemType;
				var widget = $scope.$parent.$parent.widget;
				var reactDrilldownUrl = widget.reactDrilldownUrl;
				var sorters = widget.reactDrilldownSorters;
				var mandatoryColumns = widget.reactDrilldownMandatoryColumns;
				filterQueryParams = drilldownFunctionsService.getDrilldownParamArray(filterQueryParams);
				widget.drillDownUrl = reactDrilldownUrl + drilldownFunctionsService.makeDrilldownParamString(filterQueryParams, true, sorters, false, mandatoryColumns);
			} else {
				$timeout(loadData, 100);
			}
		}

		function setWidgetTitle() {
			$scope.$parent.$parent.definition.config.title = $scope.$parent.$parent.widget.name +
								' (' + $scope.settings.itemType + ')';
		}

		loadData();
	}
})();
